<script>
import { RegisterNode } from 'vg-editor';

export default {
  name: 'FlowCustomNode',

  render() {
    const config = {
      draw(item) {
        const keyShape = this.drawKeyShape(item);

        this.drawLabel(item);

        const group = item.getGraphicGroup();
        const model = item.getModel();

        group.addShape('image', {
          attrs: {
            width: 70,
            height: 70,
            x: -35,
            y: -35,
            img: model.icon,
          },
        });

        return keyShape;
      },
    };

    return <register-node name='flow-custom-node' config={config} extend={'flow-circle'}/>;
  },

  components: { RegisterNode },
};
</script>
